import type { SVGProps } from 'react';
const IcoExternal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 10"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path d="M9.5 5a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3a.5.5 0 1 0 0-1h-3A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10h7A1.5 1.5 0 0 0 10 8.5v-3a.5.5 0 0 0-.5-.5" />
      <path d="M7.5 1h.79L5.145 4.14a.5.5 0 0 0 .163.82.5.5 0 0 0 .547-.11L9 1.71v.79a.5.5 0 1 0 1 0v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 1 0 0 1" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h10v10H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default IcoExternal;
